import React from 'react'
import PropTypes from 'prop-types'
import IconButton from '../buttons/icon-button'

const Actions = props => (
  <div className='actions'>
    <IconButton iconName='edit' onClick={props.onEdit} />
    <IconButton iconName='delete-bin' onClick={props.onDelete} />
  </div>
)

Actions.propTypes = {
  onEdit: PropTypes.func,
  onDelete: PropTypes.func
}

export default Actions



// WEBPACK FOOTER //
// ./src/ui/buttons/actions.js